<template>
  <div class="bet-slip-confirmation-content bet-slip-fixed-content">
    <div class="confirmation-wrapper">
      <div class="rows-wrapper">
        <bet-slip-confirmation :bet-response-source="confirmationData" :is-confirmation="true"></bet-slip-confirmation>
      </div>
      <div class="actions-modal mt-3 d-flex justify-content-center mb-2 btn-confirm-buttons">
        <a
          class="btn btn-large d-flex align-items-center justify-content-center btn-modify btn-confirm-button"
          style="height: 36px"
          :disabled="betPlaceStatus.loading"
          @click.prevent="setCurrentState('BET_PREPARE')"
          :class="{
            'btn-loading-anim': betPlaceStatus.loading,
            disabled: betPlaceStatus.loading,
          }"
        >
          {{ $t('BetSlip.Modify Amounts') }}
        </a>
        <a
          href
          class="
            btn btn-green btn-large
            mb-2 mb-sm-0
            d-flex
            align-items-center
            justify-content-center
            btn-confirm-button
            text-nowrap
          "
          style="height: 36px"
          @click.prevent="clickPlaceBet()"
          :disabled="betPlaceStatus.loading"
          :class="{
            disabled: hasConfirmationError() || betPlaceStatus.loading,
            'btn-orange': isConfirmOddsChanged,
          }"
        >
          <span v-if="!betPlaceStatus.loading" class="text-uppercase">
            {{ $t(isConfirmOddsChanged ? 'BetSlip.AcceptAll' : 'BetSlip.Confirm') }}</span
          >
          <span v-if="!!countDown" class="mr-2"> {{ countDown }}</span>
          <i class="fa fa-spin fa-spinner" v-if="betPlaceStatus.loading"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import BetSlipConfirmation from './BetSlipConfirmation';
import ConfirmationModal from '@/components/shared/BonusModal';
import { isLive } from '@/views/sports/components/bet-slip/check-bets';
export default {
  components: {
    BetSlipConfirmation,
    ConfirmationModal,
  },
  data() {
    return {
      countDown: null,
      timer: null,
    };
  },
  watch: {
    betPlaceStatus: function (value) {
      if (value && value.loading === true && this.liveCount) {
        this.startTimer();
      }

      if (value && value.loading === false) {
        clearTimeout(this.timer);
      }
    },
  },
  computed: {
    ...mapState({
      betTabs: (state) => state.betSlip.betTabs,
      selectedType: (state) => state.betSlip.selectedType,
      currentState: (state) => state.betSlip.currentState,
      betOptionsResponse: (state) => state.betSlip.betOptionsResponse,
      betOptionsStatus: (state) => state.betSlip.betOptionsStatus,
      betConfirmationResponse: (state) => state.betSlip.betConfirmationResponse,
      betPlaceStatus: (state) => state.betSlip.betPlaceStatus,
      confirmationData: (state) => state.betSlip.confirmationData,
    }),
    ...mapGetters({
      liveBetDelay: 'settings/liveBetDelay',
    }),
    liveCount() {
      return this.betConfirmationResponse.Selections.reduce((acc, curr) => acc + !!isLive(curr.OutComeId), 0);
    },
    isConfirmOddsChanged() {
      return this.betConfirmationResponse.Selections.some((l) => l.wait_for_accept_get_confirmation);
    },
  },
  methods: {
    ...mapActions({
      placeBet: 'betSlip/placeBet',
      logoutAndRefresh: 'player/logoutAndRefresh',
      fillConfirmationData: 'betSlip/fillConfirmationData',
    }),
    ...mapMutations({
      setCurrentState: 'betSlip/setCurrentState',
    }),
    hasConfirmationError() {
      return !this.betConfirmationResponse.IsSuccess;
    },
    countDownTimer() {
      if (this.countDown > 0 && this.liveCount > 0) {
        this.timer = setTimeout(() => {
          this.countDown -= 1;
          this.countDownTimer();
        }, 1000);
      }
    },
    startTimer() {
      if (this.liveBetDelay >= 3) {
        this.countDown = this.liveBetDelay;
        this.countDownTimer();
      }
    },
    clickPlaceBet() {
      if (this.isConfirmOddsChanged) {
        this.confirmationData.forEach((bet) => {
          bet.Selections.forEach((selection) => {
            selection.wait_for_accept_get_confirmation = false;
          });
        });
      }
      this.placeBet();
    },
  },
  created() {
    this.fillConfirmationData();
  },
};
</script>

<style>
.btn.btn-modify {
  color: #495057 !important;
}

.btn.btn-modify:hover {
  color: #343a40 !important;
  border-color: #495057;
}

.btn-confirm-buttons {
  gap: 10px;
  padding-left: 10px !important;
  padding-right: 10px !important;
}
.btn-confirm-button {
  width: 50% !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  flex-shrink: 0;
}
</style>
